/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/AddNewKeyPanel" />
import React = require("react");
import { filterXSS } from "xss";
import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";

import { Panel } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";
import { VssComponent } from "VSS/Platform/Layout";
import { ObservableValue } from "VSS/Core/Observable";
import { Observer } from "VSSUI/Observer";
import { FormItem } from "VSSUI/FormItem";

export interface IProfileSSHPublicKeysProps {
    onSave: (name: string, dataKey: string) => void;
    onDismiss: () => void;
}

export default class SSHPublicKeysAddPanel extends VssComponent<IProfileSSHPublicKeysProps> {
    private static readonly keyBeggining = "ssh-rsa";

    private _name = new ObservableValue<string>("");
    private _dataKey = new ObservableValue<string>("");
    private _isDataKeyInvalid = new ObservableValue<boolean>(false);
    private _dataKeyMessage = new ObservableValue<string>("");

    public render() {
        const panelContent = (
            <div className="flex-colum flex-grow rhythm-vertical-20">
                <FormItem className="fontWeightSemiBold" label={this._renderRequiredFieldLabel(Resources.Name)}>
                    <TextField
                        className="nameInputField"
                        aria-label={Resources.Name}
                        required={true}
                        value={this._name}
                        onChange={this._onNameChange}
                    />
                </FormItem>
                <FormItem
                    className="fontWeightSemiBold"
                    label={this._renderRequiredFieldLabel(Resources.KeyData)}
                    message={this._dataKeyMessage}
                    error={this._isDataKeyInvalid}
                >
                    <TextField
                        aria-label={Resources.KeyData}
                        multiline={true}
                        required={true}
                        rows={9}
                        value={this._dataKey}
                        onChange={this._onDataKeyChange}
                    />
                </FormItem>
            </div>
        );
        return (
            <Observer name={this._name} dataKey={this._dataKey}>
                {(props: { name: string; dataKey: string }) => (
                    <Panel
                        className="flex-column"
                        defaultActiveElement=".nameInputField input"
                        onDismiss={this.props.onDismiss}
                        titleProps={{ text: Resources.AddSSHKeyPanelTitle }}
                        footerButtonProps={[
                            {
                                text: Resources.Cancel,
                                onClick: this.props.onDismiss
                            },
                            {
                                text: Resources.Add,
                                primary: true,
                                onClick: this._onSave,
                                disabled: !filterXSS(props.name) || !props.dataKey || this._isDataKeyInvalid.value
                            }
                        ]}
                    >
                        {panelContent}
                    </Panel>
                )}
            </Observer>
        );
    }

    private _renderRequiredFieldLabel(label: string) {
        return <span className="required-field">{label}</span>;
    }

    private _onSave = () => {
        this.props.onSave(filterXSS(this._name.value).trim(), this._dataKey.value.trim());
    };

    private _onNameChange = (ev: any, value: string) => {
        this._name.value = value;
    };

    private _onDataKeyChange = (ev: any, value: string) => {
        this._isDataKeyInvalid.value = value != "" && !value.startsWith(SSHPublicKeysAddPanel.keyBeggining);
        this._dataKeyMessage.value = this._isDataKeyInvalid.value ? Resources.InvalidSshRsaKey : "";
        this._dataKey.value = value;
    };
}
